// Exmaple OID = 00u1dlspcnQDRd57k357
const oktaIDRegex = /^00u[a-zA-Z0-9]{17}$/;

export default id => id.match(oktaIDRegex);
